module.exports = __webpack_public_path__ + "static/media/corporate-culture-01.58fd14fd.png";